import { render, staticRenderFns } from "./IconWhatsApp.vue?vue&type=template&id=6708b0de&"
import script from "./IconWhatsApp.vue?vue&type=script&lang=ts&"
export * from "./IconWhatsApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports